import React from "react";
import styled from "styled-components";

import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

const PDFDetail = ({ order, ViewPDF, DeleteElement }) => {
  const viewPdfClick = () => ViewPDF && ViewPDF;
  return (
    <PDFDetailStyled>
      <div onClick={viewPdfClick}>
        <PictureAsPdfIcon />
        {order.originalFilename}
      </div>
      {DeleteElement && DeleteElement}
    </PDFDetailStyled>
  );
};

export default PDFDetail;

const PDFDetailStyled = styled.div`
  ${(props) => {
    let current = props.theme;
    return `
        border-bottom:1px solid rgba(${current.black},0.0625);
        padding:${current.gSM};
        margin-bottom:${current.gSM};
        display:flex;
        >div{
            display:flex;
            flex-grow:1;
            cursor:pointer;
            >svg{
              margin-right:10px;
            }
        }
        svg.danger{
            color:rgba(${current.red},1);
            cursor:pointer;
        }
        :hover{
            background:rgba(${current.black},0.0625);
        }
        `;
  }}
`;
